import Vue from "vue";
import * as MutationsType from "./mutationsType";
import { roles } from "@/helpers/get_constants";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.IS_AGENT_AUTHENTICATED](state, payload) {
    state.isAgentAuthenticated = payload;
  },
  [MutationsType.SET_AGENT](state, payload) {
    state.agent = payload;
  },
  [MutationsType.SET_AGENTS](state, payload) {
    state.agents = payload;
  },
  [MutationsType.ADD_AGENT](state, payload) {
    if (state.agents) state.agents.unshift(payload);
  },
  [MutationsType.SET_ALL_AGENTS](state, payload) {
    state.allAgents = payload;
  },
  [MutationsType.SET_ALL_AGENTS_MAP](state, payload) {
    state.allAgentsMap = payload;
  },
  [MutationsType.UPDATE_AGENT](state, payload) {
    let ind = state.allAgents?.findIndex((agent) => agent.uid === payload.uid);
    if (ind >= 0) Vue.set(state.allAgents, ind, { ...state.allAgents[ind], ...payload });

    if (payload.uid === state.agent.uid) state.agent = { ...state.agent, ...payload };
  },
  [MutationsType.SET_AGENT_SELECTED](state, payload) {
    state.agentSelected = payload;
  },
  [MutationsType.SHOW_AGENT_DETAIL](state, payload) {
    state.agentId = payload;
    state.showAgentDetailDrawer = !state.showAgentDetailDrawer;
  },
  [MutationsType.SET_MENU_ITEMS](state, payload) {
    let items = [];

    if ([roles.SUPER_ADMIN, roles.ADMIN, roles.ENTREPRENEUR].includes(payload.role))
      items.push(
        state.menuStatistics,
        state.menuBusiness,
        state.menuCatalog,
        state.menuCampaigns,
        state.menuChannels,
        ...state.menuBase,
        state.menuSegments,
        state.menuOrder,
        state.menuLoyalty,
        state.menuAgents,
        state.menuWarehouse,
        state.menuCoach,
      );

    if ([roles.ADVISOR, roles.SUPERVISOR].includes(payload.role)) items = [...state.menuBase, state.menuCoach];

    if (roles.ADVISOR_LEVEL1 === payload.role) items.push(state.menuChannelOnlyPOS, state.menuOrder);

    if (roles.ADVISOR_LEVEL2 === payload.role)
      items.push(state.menuChannelOnlyWhatsApp, state.menuTickets, state.menuEvents, state.menuOrder, state.menuCoach);

    state.menu = items;
  },
};
